import React, { createContext, useState, useContext, useMemo } from "react";

import { getUserByToken } from "../app/modules/Auth/_redux/authCrud";

// --------------------
// Context
// --------------------

export const DataContext = createContext(undefined);

export const useDataContext = () => {
  const ctx = useContext(DataContext);
  if (!ctx) {
    throw new Error("useDataContext must be used within DataProvider");
  }
  return ctx;
};

// --------------------
// Provider
// --------------------

const DataProvider = ({ children }) => {
  const [profiles, setProfiles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // --------------------
  // Fetch function (manual call)
  // --------------------
  const getProfileData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getUserByToken();
      setProfiles(response);
    } catch (err) {
      setError(err?.message || "Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  const value = useMemo(
    () => ({
      profiles,
      setProfiles,
      loading,
      error,
      getProfileData, // Export function
    }),
    [profiles, loading, error]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export default DataProvider;
